import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges, HostListener } from '@angular/core';
import { ConfigParamsService } from '../../services/configParameters/config-params.service';
import { LoginService } from '../../services/login/login.service';
import { EditionLayerAttr } from '../../models/edition-layer-attr';
import { EditionLayer } from '../../models/edition-layer';
import { EditionLayerStyles } from '../../models/edition-layer-styles';

@Component({
  selector: 'app-layer-grid',
  templateUrl: './layer-grid.component.html',
  styleUrls: ['./layer-grid.component.css']
})
export class LayerGridComponent implements OnInit, OnChanges {
  protected configLayers: any;
  //  @Input() showgrid;
  public autoRedirecting = false;
  protected editionLayers: Array<EditionLayer> = [];
  protected rowHeight = (window.innerHeight - 90) * (this.getColumnsPerCentGrid()) + 'px';
  protected colspanGRID = 1;
  protected rowspanGRID = 1;
  protected cols = 1;
  @Output() layerToEdit = new EventEmitter<EditionLayer>();
  public layersLoaded = false;

 constructor(private loginService: LoginService, protected configParamsService: ConfigParamsService) {
    console.debug(' >>> LayerGridComponent: constructor');
    const layerType = this.configParamsService.isPrivateApp() ? 'privat' : 'public';
    this.configLayers = this.configParamsService.getConfigFile(layerType).then(data => {
      this.configLayers = data;
      this.initLayerGrid(this.configLayers.layers);
      this.rowHeight = (window.innerHeight - 90) * (this.getColumnsPerCentGrid()) + 'px';
    });
  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    console.debug('>>> IdentifyControlComponent: ngOnChanges');
    try {
      this.rowHeight = (window.innerHeight - 90) * (this.getColumnsPerCentGrid()) + 'px';
    }
    catch (e) { console.warn('Ups, hi ha hagut algun problema al ngOnChanges del identify-control.component.ts', e); }
  }

  private getColumnsPerCentGrid(): number {
    if (window.orientation > 0) {
      this.cols = 2;
      return 1;
    }
    else if (window.innerWidth > 1200) {
      this.cols = 3;
      return 1 / 3;
    }
    else if (window.innerWidth > 960) {
      this.cols = 2;
      return 1 / 3;
    }
    else {
      this.cols = 1;
      return 1 / 2;
    }
  }
  initLayerGrid(layersObj) {
    for (const layerName in layersObj) {
      const editionLayer = this.initEditionLayer(layersObj[layerName]);
      if (editionLayer != null){
        editionLayer.nom_capa = layerName;
        const arrTMP = this.configParamsService.getEditionLayersBy('nom_capa', editionLayer.nom_capa);
        if (arrTMP.length === 0) {
          this.configParamsService.pushEditionLayer(editionLayer);
        } else {
          console.warn('La capa ' + layerName + ' esta repetida al fitxer de configuració. Repassa-ho!');
        }
      }
    }
    this.editionLayers = this.configParamsService.getEditionLayers();
    if (!this.configParamsService.isPrivateApp() && this.editionLayers.length === 1) {
      this.autoRedirecting = true;
      setTimeout(() => {
        this.accedirVisor(this.editionLayers[0]);
      }, 500);
    }
    this.layersLoaded = true;
  }

  initEditionLayer(layerObj): EditionLayer {
    const layer = new EditionLayer();

    for (const propietat_nom in layerObj) {
      switch (propietat_nom) {
        case 'capes':
          layer.capes = layerObj[propietat_nom];
          break;
        case 'nomCampGeometria':
          layer.geometria_camp = layerObj[propietat_nom];
          break;
        case 'tipusGeometria':
          layer.geometria_tipus = layerObj[propietat_nom];
          break;
        case 'namespace':
          layer.namespace = layerObj[propietat_nom];
          break;
        case 'prefix':
          layer.prefix = layerObj[propietat_nom];
          break;
        case 'url':
          layer.url = layerObj[propietat_nom];
          break;
        case 'base_url_imatges':
          layer.base_url_imatges = layerObj[propietat_nom];
          break;
        case 'carpeta_imatges':
          layer.carpeta_imatges = layerObj[propietat_nom];
          break;
        case 'previewIniciIMG':
          layer.thumbnail = layerObj[propietat_nom];
          break;
        case 'nomCampEtiqueta':
          layer.nom_camp_etiqueta = layerObj[propietat_nom];
          break;
        case 'atributs':
          layer.atributs = this.initEditionLayerAttr(layerObj[propietat_nom]);
          break;
        case 'estils':
          layer.estils = this.initEditionLayerStyles(layerObj[propietat_nom]);
          break;
        case 'max_features':
          layer.max_features = layerObj[propietat_nom];
          break;
        case 'userId':
          layer.user_id = layerObj[propietat_nom];
          break;
        case 'list_view_title_field':
          const titleField = layerObj[propietat_nom];
          layer.list_view_title_field = titleField;
          break;
      }
    }

    if (!this.configParamsService.isPrivateApp() || layer.isVisible(this.loginService.getUsername())) {
      return layer;
    }
    return null;
  }

  initEditionLayerStyles(stylesObj): EditionLayerStyles[]{
    const arrResults = [];
    for (let index = 0; index < stylesObj.length; index++) {
      const style = new EditionLayerStyles();
      style.color_interior = stylesObj[index]['color_interior'];
      style.radi_punt = stylesObj[index]['radi_punt'];
      style.color_border = stylesObj[index]['color_border'];
      style.mida_border = stylesObj[index]['mida_border'];
      style.mida_etiqueta = stylesObj[index]['mida_etiqueta'];
      style.color_etiqueta = stylesObj[index]['color_etiqueta'];
      arrResults.push(style);
    }
    return arrResults;
  }

  initEditionLayerAttr(layerAttrObj): EditionLayerAttr[] {
    const edtAttrArray = [];

    for (let index = 0; index < layerAttrObj.length; index++) {
      const edtAttr = new EditionLayerAttr();
      const atribut = layerAttrObj[index];
      let hasAmagat = false;

      for (const propietat_nom in atribut) {
        switch (propietat_nom) {
          case 'camp':
            edtAttr.camp = atribut[propietat_nom];
            break;
          case 'editable':
            edtAttr.editable = atribut[propietat_nom];
            break;
          case 'format':
            edtAttr.format = atribut[propietat_nom];
            break;
          case 'longitudMax':
            edtAttr.longitudMax = atribut[propietat_nom];
            break;
          case 'nom':
            edtAttr.nom = atribut[propietat_nom];
            break;
          case 'link':
            edtAttr.link = atribut[propietat_nom];
            break;
          case 'obligatori':
            edtAttr.obligatori = atribut[propietat_nom];
            break;
          case 'valors':
            edtAttr.valors = atribut[propietat_nom];
            break;
          case 'amagat':
            edtAttr.amagat = atribut[propietat_nom];
            hasAmagat = true;
            break;
          case 'removeIfEmpty':
            edtAttr.removeIfEmpty = atribut[propietat_nom];
            break;
        }
      }

      if (!hasAmagat) {
        edtAttr.amagat = false;
      }

      edtAttrArray.push(edtAttr);
    }

    return edtAttrArray;
  }

  accedirVisor(layerSelected) {
    this.configParamsService.setSelectedEditionLayer(layerSelected);
  }


  /*
 * Escoltem l'event de resize de les finestres, per ajustar el mapa a la vista.
 */
  @HostListener('window:resize', ['$event'])
  public onResize(event) {
    console.debug('>>> MapComponent: onResize');
    this.rowHeight = (window.innerHeight - 90) * (this.getColumnsPerCentGrid()) + 'px';
  }

  /*
 * Escoltem l'event de resize de les finestres, per ajustar el mapa a la vista.
 */
  @HostListener('window:orientationchange', ['$event'])
  public orientationChange(event) {
    console.debug('>>> MapComponent: orientationChange');
    this.rowHeight = (window.innerHeight - 90) * (this.getColumnsPerCentGrid()) + 'px';
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/components/layer-grid/layer-grid.component.ts